import { render, staticRenderFns } from "./ReferrerControl.vue?vue&type=template&id=6367ea7e&scoped=true"
import script from "./ReferrerControl.vue?vue&type=script&lang=js"
export * from "./ReferrerControl.vue?vue&type=script&lang=js"
import style0 from "./ReferrerControl.vue?vue&type=style&index=0&id=6367ea7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6367ea7e",
  null
  
)

export default component.exports